<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title *ngIf="Mode == 'reversal'" i18n=":@@modal_balance_reversal.title">Estorno</ion-title>
        <ion-title *ngIf="Mode == 'transfer'" i18n=":@@modal_balance_reversal.title-transfer">Transferir para a carteira</ion-title>

        <ion-button title="fechar" style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end"
            (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

    <div class="reversal-modal">

        <p class="campaign">
            <ion-icon name="ribbon-outline"></ion-icon>
            <span>{{ CampaignName }}</span>
        </p>

        <p class="process-info">
            <ion-icon name="information-circle-outline"></ion-icon>
            <span *ngIf="Mode == 'reversal'" i18n=":@@modal_balance_reversal.process">O estorno transfere o saldo da carteira do cliente para a sua conta bancária.</span>
            <span *ngIf="Mode == 'transfer'" i18n=":@@modal_balance_reversal.process-transfer">A transferência move o saldo da campanha para o saldo da carteira do cliente.</span>
        </p>

        <div class="max-box">
            <div class="max-info">
                <span class="max-label" i18n=":@@modal_balance_reversal.max">Máximo disponível</span>
                <span class="max-value">{{ MaxAmount | currencyEuro }}</span>
            </div>

            <ion-button fill="clear" size="small" (click)="OnUseMax()" i18n=":@@modal_balance_reversal.use-max">
                Usar máximo
            </ion-button>
        </div>

        <label class="field-label" for="reversal-amount">
            <ng-container *ngIf="Mode == 'reversal'" i18n=":@@modal_balance_reversal.amount">Valor a estornar</ng-container>
            <ng-container *ngIf="Mode == 'transfer'" i18n=":@@modal_balance_reversal.amount-transfer">Valor a transferir</ng-container>
        </label>

        <ion-input id="reversal-amount" class="amount-input" [class.invalid]="Validation.error" type="text"
            inputmode="decimal" autocomplete="off" placeholder="Ex.: 25.50" [formControl]="Amount"
            (keyup.enter)="OnConfirm()">
            <span slot="end" class="currency">€</span>
        </ion-input>

        <small class="field-hint" [class.error]="Validation.error">
            <ng-container *ngIf="Validation.error; else hint">
                <ion-icon name="alert-circle-outline"></ion-icon> {{ Validation.error }}
            </ng-container>
            <ng-template #hint>
                <ng-container i18n=":@@modal_balance_reversal.hint">Formato 0.00, com ponto ou vírgula e até 2 casas decimais.</ng-container>
            </ng-template>
        </small>

        <div class="summary" *ngIf="Validation.amount !== null">
            <span *ngIf="Mode == 'reversal'" i18n=":@@modal_balance_reversal.summary">Valor a estornar</span>
            <span *ngIf="Mode == 'transfer'" i18n=":@@modal_balance_reversal.summary-transfer">Valor a transferir</span>
            <strong>{{ Validation.amount | currencyEuro }}</strong>
        </div>

    </div>

</ion-content>

<ion-footer>
    <ion-toolbar class="ion-padding-horizontal">
        <ion-buttons slot="end">
            <ion-button fill="solid" color="medium" (click)="Close()" i18n=":@@modal_balance_reversal.cancel">Cancelar</ion-button>
            <ion-button fill="solid" color="primary" [disabled]="Validation.amount === null" (click)="OnConfirm()">
                <ng-container *ngIf="Mode == 'reversal'" i18n=":@@modal_balance_reversal.confirm">Confirmar estorno</ng-container>
                <ng-container *ngIf="Mode == 'transfer'" i18n=":@@modal_balance_reversal.confirm-transfer">Confirmar transferência</ng-container>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>
